import React, { useEffect, useState } from "react";
import SapakimHead from "./SapakimHead";
import { useParams } from "react-router-dom";
import Loading from "../Components/Loading";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../Components/Firebase";
import '../Styles/Sapakim/SViewOrder.css';

function SViewOrder() {
  const { CDID, ORID } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);

  useEffect(() => {
    const fetchOrderAndCustomer = async () => {
      try {
        const orderRef = doc(db, "Orders", ORID);
        const orderSnap = await getDoc(orderRef);

        const customerRef = doc(db, "Customers", CDID);
        const customerSnap = await getDoc(customerRef);

        if (orderSnap.exists()) {
          setOrderData(orderSnap.data());
        } else {
          console.warn("המסמך של ההזמנה לא נמצא");
        }

        if (customerSnap.exists()) {
          setCustomerData(customerSnap.data());
        } else {
          console.warn("המסמך של הלקוח לא נמצא");
        }
      } catch (err) {
        console.error("שגיאה בשליפת הנתונים:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderAndCustomer();
  }, [ORID, CDID]);

  const openModal = (url) => setModalImage(url);
  const closeModal = () => setModalImage(null);

  const handlePrint = () => {
    if (!orderData) return;

    const typeHebrewMap = {
      Upholsterer: "ריפוד",
      Carpentry: "נגרות",
      sofa: "ספה",
      bed: "מיטה",
      closet: "ארון",
    };

    const itemCount = orderData.items?.length || 0;

    const htmlContent = `
<html dir="rtl">
<head>
  <title>הדפסת הזמנה</title>
  <style>
    body {
      font-family: 'Arial', sans-serif;
      direction: rtl;
      background-color: #fff;
      color: #000;
      margin: 20px;
    }
    h1, h2 {
      border-bottom: 2px solid #333;
      padding-bottom: 5px;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    .logo {
      max-height: 150px;
    }
    .order-details {
      margin-bottom: 20px;
    }
    .status {
      font-weight: bold;
      padding: 5px 10px;
      border-radius: 5px;
      background: #f0f0f0;
      display: inline-block;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      page-break-inside: auto;
    }
    th, td {
      text-align: right;
      border: 1px solid #ccc;
      padding: 10px;
      vertical-align: top;
      word-break: break-word;
      white-space: normal;
    }
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    .full-width-row td {
      background: #f9f9f9;
    }
    img {
      max-width: 80px;
      max-height: 80px;
      margin: 4px;
    }
    .shape-img {
      max-width: 100px;
      border: 1px solid #ccc;
      margin-bottom: 10px;
    }
    .page-break {
      page-break-after: always;
      margin-bottom: 40px;
    }
    .summary-section {
      margin-top: 30px;
      padding: 20px;
      border: 2px solid #333;
      background: #f9f9f9;
    }
    .summary-section h3 {
      margin-top: 0;
      border-bottom: 1px solid #666;
      padding-bottom: 10px;
    }
    @media print {
      body {
        margin: 0;
      }
      .header {
        page-break-inside: avoid;
      }
      .page-break {
        page-break-after: always;
      }
    }
  </style>
</head>
<body>
  ${orderData.items?.map((item, index) => `
    <div class="page-break">
      <div class="header">
        <div>
          <h1>הזמנה מספר ${orderData.orderNumber} - פריט ${index + 1}</h1>
          <p class="status">סטטוס: ${orderData.Status}</p>
        </div>
        <div>
          <img src="https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FMilaaz1.png?alt=media&token=24f09477-3d96-4419-af28-4978ceb04997" alt="Logo" class="logo" />
        </div>
      </div>

      <div class="order-details">
        ${customerData?.Name ? `<p><strong>שם לקוח:</strong> ${customerData.Name}</p>` : ""}
        ${customerData?.Email ? `<p><strong>אימייל:</strong> ${customerData.Email}</p>` : ""}
        ${customerData?.PhoneNumber ? `<p><strong>טלפון:</strong> ${customerData.PhoneNumber}</p>` : ""}
        ${orderData.createdAt ? `<p><strong>תאריך יצירה:</strong> ${orderData.createdAt.toDate().toLocaleString()}</p>` : ""}
      </div>

      <h2>פרטי מוצר</h2>
      <table>
        <thead>
          <tr>
            <th>מס'</th>
            ${item.name ? "<th>שם</th>" : ""}
            ${item.type ? "<th>סוג</th>" : ""}
            ${item.fabricManufacturer ? "<th>חברה</th>" : ""}
            ${item.fabricCode ? "<th>מספר חומר</th>" : ""}
            ${item.width ? "<th>רוחב 1</th>" : ""}
            ${item.width2 ? "<th>רוחב 2</th>" : ""}
            ${item.height ? "<th>גובה</th>" : ""}
            ${item.depth ? "<th>עומק</th>" : ""}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            ${item.name ? `<td>${item.name}</td>` : ""}
            ${item.type ? `<td>${typeHebrewMap[item.type] || item.type}</td>` : ""}
            ${item.fabricManufacturer ? `<td>${item.fabricManufacturer}</td>` : ""}
            ${item.fabricCode ? `<td>${item.fabricCode}</td>` : ""}
            ${item.width ? `<td>${item.width} ס״מ</td>` : ""}
            ${item.width2 ? `<td>${item.width2} ס״מ</td>` : ""}
            ${item.height ? `<td>${item.height} ס״מ</td>` : ""}
            ${item.depth ? `<td>${item.depth} ס״מ</td>` : ""}
          </tr>
          <tr class="full-width-row">
            <td colspan="${2 
              + (item.name ? 1 : 0) 
              + (item.type ? 1 : 0) 
              + (item.fabricManufacturer ? 1 : 0) 
              + (item.fabricCode ? 1 : 0) 
              + (item.width ? 1 : 0) 
              + (item.width2 ? 1 : 0) 
              + (item.height ? 1 : 0) 
              + (item.depth ? 1 : 0)
            }">
              ${item.description ? `<p><strong>תיאור:</strong> ${item.description}</p>` : ""}
              ${item.woodType ? `<p><strong>סוג עץ:</strong> ${item.woodType}</p>` : ""}
              ${item.notes ? `<p><strong>הערות:</strong> ${item.notes}</p>` : ""}
              ${item.deliveryDate ? `<p><strong>תאריך אספקה:</strong> ${new Date(item.deliveryDate).toLocaleDateString()}</p>` : ""}
              ${item.shapeUrl ? `<div><strong>צורת פריט:</strong><br><img src="${item.shapeUrl}" alt="צורת פריט" class="shape-img" /></div>` : ""}
              <div>${(item.images || []).map(url => `<img src="${url}" alt="תמונה" />`).join("")}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `).join("")}

  <div class="summary-section">
    <h3>סיכום הזמנה - הזמנה מספר ${orderData.orderNumber} (${itemCount} פריטים)</h3>
    <p><strong>סטטוס הזמנה:</strong> ${orderData.Status}</p>
    <p><strong>תאריך יצירת הזמנה:</strong> ${orderData.createdAt ? orderData.createdAt.toDate().toLocaleString() : "לא זמין"}</p>
    ${orderData.items?.map((item, index) => 
      item.deliveryDate ? `<p><strong>תאריך אספקה פריט ${index + 1}:</strong> ${new Date(item.deliveryDate).toLocaleDateString()}</p>` : ""
    ).join("")}
  </div>

  <script>
    window.onload = function() {
      window.print();
      setTimeout(() => window.close(), 1000);
    };
  </script>
</body>
</html>
`;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  if (loading) return <Loading />;

  if (!orderData) {
    return <div className="p-4 text-red-500 font-semibold">ההזמנה לא נמצאה או התרחשה שגיאה.</div>;
  }

  return (
    <React.Fragment>
      <SapakimHead />
      <div className="sview-container" dir="rtl">
        <div className="sview-header-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1 className="sview-title" style={{ margin: 0 }}>פרטי הזמנה</h1>
          <button 
            onClick={handlePrint}
            className="print-button"
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            🖨️ הדפס
          </button>
        </div>

        <div className="sview-section">
          <p><span className="sview-label">סטטוס:</span> {orderData.Status}</p>
          <p><span className="sview-label">נוצר בתאריך:</span> {orderData.createdAt?.toDate().toLocaleString()}</p>
          <p><span className="sview-label">מספר הזמנה:</span> {orderData.orderNumber}</p>

          {orderData.items?.map((item, index) => (
            <p key={index}>
              <span className="sview-label">תאריך אספקה עבור פריט {index + 1}:</span>{" "}
              {item.deliveryDate ? new Date(item.deliveryDate).toLocaleDateString() : "לא נבחר"}
            </p>
          ))}
        </div>

        {customerData && (
          <>
            <h2 className="sview-subtitle">פרטי לקוח</h2>
            <div className="sview-section">
              <p><span className="sview-label">שם:</span> {customerData.Name}</p>
              <p><span className="sview-label">אימייל:</span> {customerData.Email}</p>
              <p><span className="sview-label">טלפון:</span> {customerData.PhoneNumber}</p>
            </div>
          </>
        )}

        <h2 className="sview-subtitle">פריטי ההזמנה</h2>
        {orderData.items?.map((item, index) => (
          <div key={index} className="sview-item">
            <p><span className="sview-label">שם:</span> {item.name}</p>
            <p><span className="sview-label">תיאור:</span> {item.description}</p>
            <p><span className="sview-label">סוג:</span> {item.type}</p>
            {item.fabricCode && <p><span className="sview-label">קוד בד:</span> {item.fabricCode}</p>}
            {item.fabricManufacturer && <p><span className="sview-label">יצרן בד:</span> {item.fabricManufacturer}</p>}
            {item.woodType && <p><span className="sview-label">סוג עץ:</span> {item.woodType}</p>}
            {item.width && <p><span className="sview-label">רוחב 1:</span> {item.width} ס״מ</p>}
            {item.width2 && <p><span className="sview-label">רוחב 2:</span> {item.width2} ס״מ</p>}
            {item.height && <p><span className="sview-label">גובה:</span> {item.height} ס״מ</p>}
            {item.depth && <p><span className="sview-label">עומק:</span> {item.depth} ס״מ</p>}
            {item.shapeUrl && (
              <div className="sview-shape-preview">
                <p><span className="sview-label">תמונה של הצורה:</span></p>
                <img src={item.shapeUrl} alt="צורת המוצר" style={{ maxWidth: "120px", marginTop: "8px" }} />
              </div>
            )}
            {item.notes && <p><span className="sview-label">הערות:</span> {item.notes}</p>}

            {item.images?.length > 0 && (
              <div className="sview-images">
                {item.images.map((url, i) => (
                  <img
                    key={i}
                    src={url}
                    alt={`תמונה ${i + 1}`}
                    onClick={() => openModal(url)}
                    style={{ cursor: "pointer", maxWidth: "100px", marginRight: "8px" }}
                  />
                ))}
              </div>
            )}
          </div>
        ))}

        {modalImage && (
          <div className="modal-overlay" onClick={closeModal}>
            <img
              src={modalImage}
              alt="תמונה מוגדלת"
              style={{
                maxHeight: "90%",
                maxWidth: "90%",
                boxShadow: "0 0 15px white",
                cursor: "default"
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
      
      <style jsx>{`
        @media print {
          .print-button {
            display: none !important;
          }
          .modal-overlay {
            display: none !important;
          }
          .sview-images img {
            max-width: 150px !important;
            page-break-inside: avoid;
          }
          .sview-item {
            page-break-inside: avoid;
            margin-bottom: 20px;
          }
          .sview-container {
            max-width: none !important;
            margin: 0 !important;
            padding: 20px !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
}

export default SViewOrder;